import { 
  WAIT_INIT_DEVICES, INIT_DEVICES_SUCCESS, INIT_DEVICES_FAIL, WAIT_QUERY_DEVICES, DEL_DEVICE, DEL_DEVICE_SUCCESS, // Main List
  GET_DEVICE_DETAIL, GET_DEVICE_DETAIL_SUCCESS, CLOSE_DEVICE_STATUS, SAVE_DEVICE_DETAIL, SAVE_DEVICE_DETAIL_SUCCESS, SAVE_DEVICE_DETAIL_FAIL  // Form
} from '../actions/dashboard/index';

const doMap = (state, action) => {
  switch (action.type) {
    case INIT_DEVICES_SUCCESS:
      return {
        ...state,
        devices: action.params.devices,
        errMsg: null,
        status: INIT_DEVICES_SUCCESS,
        displayDetail: false,
        loading: false,
        monitorOnline: action.params.monitorOnline,
        monitorOffline: action.params.monitorOffline
      }
    case INIT_DEVICES_FAIL:
      return {
        ...state,
        devices: [],
        errMsg: action.params.errMsg,
        status: INIT_DEVICES_FAIL,
        displayDetail: false,
        loading: true
      }
    case WAIT_INIT_DEVICES:
      return {
        ...state,
        devices: [],
        errMsg: null,
        status: WAIT_INIT_DEVICES,
        displayDetail: false,
        loading: true,
        monitorOnline: 0,
        monitorOffline: 0
      }
    case WAIT_QUERY_DEVICES:
      return {
        ...state,
        devices: [],
        errMsg: null,
        status: WAIT_QUERY_DEVICES,
        displayDetail: false,
        loading: true
      }
    case GET_DEVICE_DETAIL:
      return {
        ...state,
        displayDetail: true,
        status: GET_DEVICE_DETAIL,
        deviceDetail: {
          loading: true
        }
      }
    case GET_DEVICE_DETAIL_SUCCESS:
      const deviceDetail = action.params.deviceDetail;
      let newDeviceDetail = {
        errMsg: 'get detail fail'
      };
      if (deviceDetail && Object.keys(deviceDetail).length > 0) {
        newDeviceDetail = Object.assign({}, deviceDetail);
        newDeviceDetail['loading'] = false;
      }

      return {
        ...state,
        status: GET_DEVICE_DETAIL_SUCCESS,        
        deviceDetail: newDeviceDetail,
        deviceDetailInfo: action.params.deviceDetailInfo
      }
    case DEL_DEVICE:
      return {
        ...state,
        status: DEL_DEVICE
      }
    case DEL_DEVICE_SUCCESS:
      return {
        ...state,
        devices: action.params.devices,
        status: DEL_DEVICE_SUCCESS
      }
    case CLOSE_DEVICE_STATUS:
      return {
        ...state,
        displayDetail: false,
        deviceDetail: {
          loading: true
        },
        deviceDetailInfo: {}
      }
    case SAVE_DEVICE_DETAIL:
      return {
        ...state,
        status: SAVE_DEVICE_DETAIL,
        errMsg: null,
        deviceDetail: {
          ...state.deviceDetail,
          loading: true
        },
      }
    case SAVE_DEVICE_DETAIL_SUCCESS:
      return {
        ...state,
        status: SAVE_DEVICE_DETAIL_SUCCESS,
        deviceDetail: {
          loading: true
        },
      }
    case SAVE_DEVICE_DETAIL_FAIL:
      return {
        ...state,
        status: SAVE_DEVICE_DETAIL_FAIL,
        errMsg: action.params.errMsg,
        deviceDetail: {
          ...state.deviceDetail,
          loading: false
        },
      }
  default:
      return state;
    }
}

const dashboardReducers = (state = {
  devices: [],
  monitorOnline: 0,
  monitorOffline: 0,
  errMsg: null,
  successMsg: null,
  status: WAIT_INIT_DEVICES,
  displayDetail: false,
  deviceDetail: {
    loading: true
  },
  deviceDetailInfo: {},
  loading: true
}, action) => {
  switch (action.type) {
    default:
      return doMap(state, action);
  }
}

export default dashboardReducers;